<div class="container extra-space">

  <div *ngIf="isClientOnlyAction" class="row mb-5 step-indicator-container">
    <div class="col-12 ps-0">
      <c11n-internal-callout variant="vertical" [headingLevel]="2">
        <p class="c11n-text-md-bold" [innerHtml] = "editInternalOnly"></p>
      </c11n-internal-callout>
    </div>
  </div>

  <div class="step-indicator-container">
    <app-step-indicator [currentStep]="(currentStepIndicatorIndex$ | async) || 1"
      [thirdpartyDocumentsAemContent]="thirdpartyDocumentsAemContent">
    </app-step-indicator>
  </div>

  <div class="c11n-banner c11n-banner--medium c11n-banner--error mb-3" *ngIf="showLineCountError" tabIndex="0" [attr.aria-label]="lineCountErrorMessage">
    <div class="c11n-banner__leading-icon">
      <svg class="c11n-error-small" role="img" aria-hidden="false" focusable="true">
        <title>error</title>
        <use xlink:href="#error-small"></use>
      </svg>
    </div>
    <div class="c11n-banner__main">
      <div class="c11n-banner__content">
        <div class="c11n-banner__body">
          <div class="c11n-text-md--crop">{{ lineCountErrorMessage }}</div>
        </div>
      </div>
    </div>
  </div>

  <p class="header-label">{{title}}</p>
  <a c11n-link type="button" class="address-text-1" (click)="showUsAddress = !showUsAddress">
    <ng-template [ngIf]="showUsAddress"><span>{{ this.content.STEP1_NON_US_ADDR }} »</span></ng-template>
    <ng-template [ngIf]="!showUsAddress"><span>{{this.content.STEP1_US_ADDR}} »</span></ng-template>
  </a>

  <p class="description-text" [innerHTML]="content.STEP1_INFO"></p>

  <div class="add-address-container">
    <form (ngSubmit)="addUserAddress(addressForm)" #addressForm="ngForm">
      <div class="col-12 col-sm-12 col-lg-12 col-xl-12 ">
        <label c11n-label for="firstname">{{this.content.NAME_Label}}</label>
        <c11n-input
          [hasError]="checkValid(!firstname?.valid && firstname?.touched || !firstname?.valid && addressForm?.submitted) || maxLengthHit['firstname']">
          <input c11nInput type="text" inputmode="text" id="firstname" name="firstname" ngModel
            aria-describedby="First Name" placeholder="" required #firstname="ngModel" pattern="[a-zA-Z0-9][a-zA-Z0-9\s]{0,29}"
            maxlength="30" (keydown)="onKeydown($event, 'firstname')" (paste)="onPaste($event, 'firstname')" (drop)="onDrop($event, 'firstname')">
        </c11n-input>
        <c11n-hint-error
          [hasError]="checkValid(!firstname?.valid && firstname?.touched || !firstname?.valid && addressForm?.submitted) || maxLengthHit['firstname']"
          hintText="" [errorText]="maxLengthHit['firstname'] ? errorMessages.nameMaxLength : getNameError(firstname)" [hintErrorId]="'firstname-error'"></c11n-hint-error>
      </div>

      <div class="col-12 col-sm-12 col-lg-12 col-xl-12 mt-2" *ngIf="numberNameLines >= 2">
        <label c11n-label for="nameLine2">Name line 2</label>
        <div class="name-line-wrapper">
          <c11n-input
            [hasError]="checkValid(!nameLine2Ref?.valid && nameLine2Ref?.touched || !nameLine2Ref?.valid && addressForm?.submitted) || maxLengthHit['nameLine2']">
            <input c11nInput type="text" inputmode="text" id="nameLine2" name="nameLine2" ngModel
              placeholder="" #nameLine2Ref="ngModel" pattern="[a-zA-Z0-9][a-zA-Z0-9\s]{0,29}" maxlength="30"
              (keydown)="onKeydown($event, 'nameLine2')" (paste)="onPaste($event, 'nameLine2')" (drop)="onDrop($event, 'nameLine2')">
          </c11n-input>
          <button type="button" class="name-line-remove-btn" (click)="removeNameLine(2)" aria-label="Remove name line 2">&#x2715;</button>
        </div>
        <c11n-hint-error
          [hasError]="checkValid(!nameLine2Ref?.valid && nameLine2Ref?.touched || !nameLine2Ref?.valid && addressForm?.submitted) || maxLengthHit['nameLine2']"
          hintText="" [errorText]="maxLengthHit['nameLine2'] ? errorMessages.nameMaxLength : getNameError(nameLine2Ref)"
          [hintErrorId]="'nameLine2-error'"></c11n-hint-error>
      </div>

      <div class="col-12 col-sm-12 col-lg-12 col-xl-12 mt-2" *ngIf="numberNameLines >= 3">
        <label c11n-label for="nameLine3">Name line 3</label>
        <div class="name-line-wrapper">
          <c11n-input
            [hasError]="checkValid(!nameLine3Ref?.valid && nameLine3Ref?.touched || !nameLine3Ref?.valid && addressForm?.submitted) || maxLengthHit['nameLine3']">
            <input c11nInput type="text" inputmode="text" id="nameLine3" name="nameLine3" ngModel
              placeholder="" #nameLine3Ref="ngModel" pattern="[a-zA-Z0-9][a-zA-Z0-9\s]{0,29}" maxlength="30"
              (keydown)="onKeydown($event, 'nameLine3')" (paste)="onPaste($event, 'nameLine3')" (drop)="onDrop($event, 'nameLine3')">
          </c11n-input>
          <button type="button" class="name-line-remove-btn" (click)="removeNameLine(3)" aria-label="Remove name line 3">&#x2715;</button>
        </div>
        <c11n-hint-error
          [hasError]="checkValid(!nameLine3Ref?.valid && nameLine3Ref?.touched || !nameLine3Ref?.valid && addressForm?.submitted) || maxLengthHit['nameLine3']"
          hintText="" [errorText]="maxLengthHit['nameLine3'] ? errorMessages.nameMaxLength : getNameError(nameLine3Ref)"
          [hintErrorId]="'nameLine3-error'"></c11n-hint-error>
      </div>

      <div class="col-12 col-sm-12 col-lg-12 col-xl-12 mt-2" *ngIf="numberNameLines >= 4">
        <label c11n-label for="nameLine4">Name line 4</label>
        <div class="name-line-wrapper">
          <c11n-input
            [hasError]="checkValid(!nameLine4Ref?.valid && nameLine4Ref?.touched || !nameLine4Ref?.valid && addressForm?.submitted) || maxLengthHit['nameLine4']">
            <input c11nInput type="text" inputmode="text" id="nameLine4" name="nameLine4" ngModel
              placeholder="" #nameLine4Ref="ngModel" pattern="[a-zA-Z0-9][a-zA-Z0-9\s]{0,29}" maxlength="30"
              (keydown)="onKeydown($event, 'nameLine4')" (paste)="onPaste($event, 'nameLine4')" (drop)="onDrop($event, 'nameLine4')">
          </c11n-input>
          <button type="button" class="name-line-remove-btn" (click)="removeNameLine(4)" aria-label="Remove name line 4">&#x2715;</button>
        </div>
        <c11n-hint-error
          [hasError]="checkValid(!nameLine4Ref?.valid && nameLine4Ref?.touched || !nameLine4Ref?.valid && addressForm?.submitted) || maxLengthHit['nameLine4']"
          hintText="" [errorText]="maxLengthHit['nameLine4'] ? errorMessages.nameMaxLength : getNameError(nameLine4Ref)"
          [hintErrorId]="'nameLine4-error'"></c11n-hint-error>
      </div>

      <div class="col-12 col-sm-12 col-lg-12 col-xl-12 mt-2 mb-2">
        <a c11n-link type="button" (click)="addNameLine()" *ngIf="numberNameLines < 4">
          <span>Click to add additional name</span>
        </a>
      </div>
      <div class="row addr-1-container">
        <div class="col-12 col-sm-12 col-lg-12 col-xl-12 ">
          <label c11n-label for="address1">{{this.content.ADDR_LABEL}}</label>
          <c11n-input
            [hasError]="checkValid(!address1?.valid && address1?.touched || !address1?.valid && addressForm?.submitted) || maxLengthHit['address1']">
            <input c11nInput type="text" inputmode="text" id="address1" name="address1" ngModel
              aria-describedby="content.HINT_TEXT" placeholder="" required #address1="ngModel" maxlength="30"
              pattern="[a-zA-Z0-9][a-zA-Z0-9\s]{0,29}" (keydown)="onKeydown($event, 'address1')" (paste)="onPaste($event, 'address1')" (drop)="onDrop($event, 'address1')">
          </c11n-input>
          <c11n-hint-error
            [hasError]="checkValid(!address1?.valid && address1?.touched || !address1?.valid && addressForm?.submitted) || maxLengthHit['address1']"
            hintText="" [errorText]="maxLengthHit['address1'] ? errorMessages.addressMaxLength : getAddressError(address1)" [hintErrorId]="'address1-error'"></c11n-hint-error>
        </div>
      </div>

      <div class="row addr-2-container">
        <div class="col-12 col-sm-12 col-lg-12 col-xl-12 ">
          <label c11n-label for="address2">{{this.content.ADDR_LINE2_LABEL}}</label>
          <c11n-input
            [hasError]="checkValid(!address2?.valid && address2?.touched || !address2?.valid && addressForm?.submitted) || maxLengthHit['address2']">
            <input c11nInput type="text" inputmode="text" id="address2" name="address2" ngModel
              aria-describedby="content.ADDR_LINE2_LABEL" placeholder="" #address2="ngModel" maxlength="30"
              pattern="[a-zA-Z0-9][a-zA-Z0-9\s]{0,29}" (keydown)="onKeydown($event, 'address2')" (paste)="onPaste($event, 'address2')" (drop)="onDrop($event, 'address2')">
          </c11n-input>
          <c11n-hint-error
            [hasError]="checkValid(!address2?.valid && address2?.touched || !address2?.valid && addressForm?.submitted) || maxLengthHit['address2']"
            hintText="" [errorText]="address2.errors?.maxlength || maxLengthHit['address2'] ? errorMessages.addressMaxLength : address2.errors?.pattern ? errorMessages.addressPattern : ''"
            [hintErrorId]="'address2-error'"></c11n-hint-error>
        </div>
      </div>

      <div class="row addr-2-container" *ngIf="showUsAddress">
        <div class="col-12 col-sm-6 city-container">
          <label c11n-label for="city">{{this.content.CITY_LABEL}}</label>
          <c11n-input [hasError]="checkValid(!city?.valid && city?.touched || !city?.valid && addressForm?.submitted)">
            <input c11nInput type="text" inputmode="text" id="city" name="city" aria-describedby="City" ngModel
              placeholder="" required #city="ngModel" maxlength="16" pattern="[a-zA-Z\s]{1,16}">
          </c11n-input>
          <c11n-hint-error
            [hasError]="checkValid(!city?.valid && city?.touched || !city?.valid && addressForm?.submitted)" hintText=""
            [errorText]="city.errors?.required ? errorMessages.cityRequired : city.errors?.pattern ? errorMessages.cityPattern : errorMessages.cityPattern"
            [hintErrorId]="'city-error'">
          </c11n-hint-error>
        </div>

        <div class="col-6 col-sm-3">
          <!-- <label c11n-label for="state">State</label>
          <c11n-input
            [hasError]="checkValid(!state?.valid && state?.touched || !state?.valid && addressForm?.submitted)">
            <input c11nInput type="text" inputmode="text" id="state" name="state" ngModel aria-describedby="State"
              placeholder="" required #state="ngModel">
          </c11n-input>
          <c11n-hint-error
            [hasError]="checkValid(!state?.valid && state?.touched || !state?.valid && addressForm?.submitted)"
            hintText="Eg. NC" errorText="State is required" [hintErrorId]="'state-error'"></c11n-hint-error>         -->
          <c11n-select [labelText]="this.content.STATE_LABEL " hintText="" [errorText]="'Required'"
            [hasError]="checkValid(!state?.valid && state?.touched || !state?.valid && addressForm?.submitted)">
            <select c11nSelectInput id="state" name="state" ngModel #state="ngModel" required>
              <option value="" data-option="placeholder" selected disabled>{{ this.content.CHOOSE_ONE }}</option>
              <option [value]="state.description" *ngFor="let state of (usStateList$ | async)">{{state['description']}}
              </option>
            </select>
          </c11n-select>

        </div>

        <div class="col-6 col-sm-3">
          <label c11n-label for="city">{{this.content.ZIP_CODE_LABEL}}</label>
          <c11n-input
            [hasError]="checkValid(!zipcode?.valid && zipcode?.touched || !zipcode?.valid && addressForm?.submitted)">
            <input c11nInput type="text" inputmode="numeric" id="zipcode" name="zipcode" ngModel
              aria-describedby="Zip code" placeholder="" [unmask]="true" [imask]="myZipMask" required #zipcode="ngModel"
              pattern="[0-9]{5}([0-9]{4})?">
          </c11n-input>
          <c11n-hint-error
            [hasError]="checkValid(!zipcode?.valid && zipcode?.touched || !zipcode?.valid && addressForm?.submitted)"
            hintText="" [errorText]="errorMessages.zipCodePattern" [hintErrorId]="'zipcode-error'"></c11n-hint-error>
        </div>
      </div>

      <div class="row country-container" *ngIf="!showUsAddress">
        <div class="col-12 col-sm-12 col-lg-12 col-xl-12 ">
          <c11n-select labelText="{{this.content.COUNTRY_LABEL}}" hintText=""
            [errorText]="this.errorMessages.countryRequired"
            [hasError]="checkValid(!country?.valid && country?.touched || !country?.valid && addressForm?.submitted)">
            <select c11nSelectInput id="country" name="country" ngModel #country="ngModel" required>
              <option value="" data-option="placeholder" selected disabled>Choose one</option>
              <option [value]="[country.code,country.description]" *ngFor="let country of (countryList$ | async)">
                {{country.description}}</option>
            </select>
          </c11n-select>
        </div>
      </div>

      <div class="row btn-container">
        <div class="col-4 col-lg-2 col-xl-2 ps-0 mb-3 mb-lg-0 btn-mobile">
          <c11n-client-only-action [isInternal]="isClientOnlyAction" [hasFloatingIcon]="false">
            <c11n-button [isInvalid]="true" buttonType="submit" [size]="'small'" variant="primary"
              [labelText]="content.COUNTINUE_LABEL" iconName="" colorMode="on-light"></c11n-button>
          </c11n-client-only-action>
        </div>
        <div class="col-4 col-lg-2 col-xl-2 ps-0 btn-mobile">
          <c11n-button buttonType="button" [size]="'small'" variant="secondary" [labelText]="content.CANCEL_LABEL"
            (clickEvent)="goToPage('home')" iconName="" colorMode="on-light"></c11n-button>
        </div>
      </div>
    </form>
  </div>
  <!-- <div class="row btn-container">
    <div class="col-4 col-lg-2 col-xl-2 ps-0 mb-3 mb-lg-0 btn-mobile">
      <c11n-button [isInvalid]="true" buttonType="submit" [size]="'small'" variant="primary" [labelText]="'Continue'"
        (clickEvent)="addUserAddress(addressForm)" iconName="" colorMode="on-light"></c11n-button>
    </div>
    <div class="col-4 col-lg-2 col-xl-2 ps-0 btn-mobile">
      <c11n-button buttonType="button" [size]="'small'" variant="secondary" [labelText]="'Cancel'"
        (clickEvent)="goToPage('')" iconName="" colorMode="on-light"></c11n-button>
    </div>
  </div> -->
</div>